import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DistributeCenterH } from '../icons';
import { ToolbarButton } from '../ui';
import { getAlignToContainer, getSelectedObjectsIDs } from '../editor';
import { getCurrentPiece, distributeObjectsCenterH } from '../project';

const ButtonDistributeCenterH = ({ disabled, onClick }) => {
  if (disabled) {
    return null;
  }

  return <ToolbarButton icon={<DistributeCenterH />} onClick={onClick} />;
};

ButtonDistributeCenterH.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const reduxConnector = connect(
  state => {
    let container = getCurrentPiece(state);
    if (!getAlignToContainer(state)) {
      container = null;
    }

    const ids = getSelectedObjectsIDs(state);
    let disabled = true;
    if (ids.size >= 2) {
      disabled = false;
    }
    return { ids, disabled, container };
  },
  { distributeObjectsCenterH },
  ({ ids, container, ...state }, actions) => ({
    ...state,
    onClick: () => actions.distributeObjectsCenterH({ ids, container }),
  }),
);

export default reduxConnector(ButtonDistributeCenterH);
